import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Grid, Divider, Typography, Box, Button, ButtonGroup, Snackbar, Alert as MuiAlert } from '@mui/material';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ZoomInRoundedIcon from '@mui/icons-material/ZoomInRounded';
import ZoomOutRoundedIcon from '@mui/icons-material/ZoomOutRounded';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { StatusComponent } from './StatusComponent'; // Correct path to StatusComponent
import './App.css';
import { useKeycloak } from '@react-keycloak/web';
import ApiConfig from '../../utils/services/apiConfig'
import { formatLocalDateTime } from '../../utils/dateTime';
import { useMountEffect } from '../../utils/hooks';

export default function DetailsPage(props){
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [alert, setAlert] = useState({})
  // const mockData = useContext(DataContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const [userResponse, setUserResponse] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  // console.log("Data from context in DetailsPage:", mockData); // Debugging point

  const initRetrieve = () => {
    Promise.all([
        apiConfig.fetchAlert(id)
    ]).then(results => {
        console.log(results[0])
        setAlert(results[0].RobotResponse)
    }).catch(error => {
        console.error(error);
    });
  }

  useMountEffect(() => {
    initRetrieve()
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // if (!alert || alert.length === 0) {
  //   return <p></p>;
  // }

  // if (!alert) {
  //   return <h5>MockData not found</h5>;
  // }

  const { Reported_By, Subcategory, Site, Location, Description, UpdatedAt, Status, Image, Timestamp } = alert;

  const handleBackClick = () => {
    // Prefer an explicit return route passed via location.state by AlertTable
    const state = location.state || {};
    // Supported state shapes:
    // { returnTo: '/alerts?page=2' }
    // { from: 'alerts', alertsQuery: '?page=2&filter=abc' }
    if (state.returnTo) {
      navigate(state.returnTo);
      return;
    }

    if (state.from === 'alerts' && state.alertsQuery) {
      navigate(`/alerts${state.alertsQuery}`);
      return;
    }

    // Fallback: try to go back in history, otherwise go to /alerts
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/alerts');
    }
  };

  const DisplayInfoPairRow = ({ label, value }) => {
    return (
      <Grid container spacing={'10px'}>
        <Grid item xs={4.5}>
          <Typography
            variant="body1"
            component="div"
            fontWeight="bold"
            sx={{
              fontSize: { xs: 16, sm: 20 },
              wordWrap: 'break-word', // Ensure long text wraps properly
              lineHeight: '1.5', // Adjust line height for better spacing
            }}
          >
            {label}
          </Typography>
        </Grid>
        <Grid item xs={7.5}>
          <Typography
            variant="body2"
            component="div"
            sx={{
              fontSize: { xs: 16, sm: 20 },
              wordWrap: 'break-word', // Ensure long text wraps properly
              lineHeight: '1.5', // Adjust line height for better spacing
            }}
          >
            {value}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const downloadImage = (base64Data, filename = 'image.png') => {
    if (!base64Data) return;
    try {
      let href = base64Data;
      if (!base64Data.startsWith('data:')) {
        // assume PNG if no mime provided
        href = `data:image/png;base64,${base64Data}`;
      }
      const link = document.createElement('a');
      link.href = href;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Failed to download image', err);
    }
  };

  const handleAlertResponse = async (response) => {
    setIsSubmitting(true);
    try {
      // Create a new alert object with updated status
      const updatedAlert = {
        ...alert,
        Status: response ? "TRUE" : "FALSE"
      };

      Promise.all([
        apiConfig.updateAlert(id, updatedAlert),
      ]).then(results => {
        console.log(results[0])
        setAlert(updatedAlert); // Update the state with the new alert object
        setUserResponse(response);
        setSnackbar({
          open: true,
          message: `Alert marked as ${response ? 'True Positive' : 'False Positive'}`,
          severity: 'success'
        });
      }).catch(error => {
        console.error(error);
        setSnackbar({
          open: true,
          message: 'Failed to submit response. Please try again.',
          severity: 'error'
        });
      });
      // Optionally navigate back after successful response
      // setTimeout(() => handleBackClick(), 1500);
    } catch (error) {
      console.error('Failed to submit response:', error);
      setSnackbar({
        open: true,
        message: 'Failed to submit response. Please try again.',
        severity: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <div className="info-page-container">
        <div className="info-container">
          {/* Header */}
          <div
            className="info-header"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between', // Ensure items are spaced propgriderly
              flexWrap: 'wrap', // Allows wrapping for smaller screens
              gap: '10px', // Adds spacing between items
              marginBottom: '10px',
            }}
          >
            {/* Back Icon */}
            <ArrowBackRoundedIcon
              onClick={handleBackClick}
              sx={{
                fontSize: { xs: 26, sm: 30, md: 32, lg: 32 },
                cursor: 'pointer',
                marginRight: { xs: '0', sm: 'auto' }, // Aligns left on all screens
              }}
              className="info-icon"
            />

            {/* Center Title */}
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                fontSize: { xs: 16, sm: 20, md: 28, lg: 32 },
                textAlign: { xs: 'center', sm: 'center', md: 'left' }, // Ensures proper alignment
                flexGrow: 1, // Helps the title stretch in mobile
                order: { xs: 2, sm: 1 }, // Ensures proper order on small screens
                width: { xs: '100%', sm: 'auto' }, // Full width on mobile
              }}
            >
              Alert {Subcategory}
            </Typography>

            {/* Status Component */}
            <StatusComponent
              value={Status}
              size={windowWidth >= 800 ? 'large' : 'small'}
              sx={{
                marginLeft: { xs: '0', sm: 'auto' }, // Adjust spacing for mobile
                order: { xs: 3, sm: 2 }, // Ensures correct order on small screens
              }}
            />
          </div>


          <Divider style={{ margin: '15px' }} />

          <Box className="info-grid-container" sx={{ padding: { xs: 1, sm: 2 } }}>
            <Grid
              container
              spacing={3}
              direction={{ xs: 'column', sm: 'row' }}
              justifyContent="center"
            >
              {/* Info */}
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                className="info-grid-column"
                sx={{ marginBottom: { xs: 2, sm: 0 } }}
              >
                <Grid container spacing={4} direction="column">
                  <Grid item>
                    <Box className="info-box" sx={{ padding: { xs: 1, sm: 2 } }}>
                      <div className="info-col">
                        <DisplayInfoPairRow label="Robot ID" value={Reported_By} />
                        <DisplayInfoPairRow label="Category" value={Subcategory} />
                      </div>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box className="info-box" sx={{ padding: { xs: 1, sm: 2 } }}>
                      <div className="info-col">
                        <DisplayInfoPairRow label="Site" value={Site} />
                        <DisplayInfoPairRow label="Location" value={Location} />
                        <DisplayInfoPairRow label="Description" value={Description} />
                        <DisplayInfoPairRow label="Updated Time" value={formatLocalDateTime(UpdatedAt)} />
                        <DisplayInfoPairRow label="Reported Time" value={formatLocalDateTime(Timestamp)} />
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              {/* Image */}
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                className="image-grid-column"
                sx={{ padding: { xs: 1, sm: 2 } }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                  }}
                >
                  <div className="info-image-wrapper" style={{ maxWidth: '100%' }}>
                    <TransformWrapper minScale={0.5} initialScale={1}>
                      {({ zoomIn, zoomOut, resetTransform }) => (
                        <>
                          <TransformComponent
                            wrapperStyle={{
                              width: '100%',
                              height: 'auto',
                              justifyContent: 'center',
                              alignItems: 'center',
                              borderRadius: '8px',
                              maxHeight: '300px',
                              overflow: 'hidden',
                              border: '2px solid #e0e0e0',
                            }}
                          >
                            <img
                              src={Image ? `data:image/png;base64,${Image}` : ""}
                              alt=""
                              className="info-image"
                              style={{
                                width: '100%',
                                objectFit: 'cover',
                                borderRadius: '8px',
                              }}
                            />
                          </TransformComponent>

                          {/* Image Controls Bar */}
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              gap: 1,
                              marginTop: 2,
                              padding: 1.5,
                              backgroundColor: 'background.default',
                              borderRadius: '8px',
                              flexWrap: 'wrap'
                            }}
                          >
                            <Button
                              startIcon={<ZoomInRoundedIcon />}
                              variant="outlined"
                              size="small"
                              onClick={() => zoomIn()}
                            >
                              Zoom In
                            </Button>
                            <Button
                              startIcon={<ZoomOutRoundedIcon />}
                              variant="outlined"
                              size="small"
                              onClick={() => zoomOut()}
                            >
                              Zoom Out
                            </Button>
                            <Button
                              startIcon={<RestartAltRoundedIcon />}
                              variant="outlined"
                              size="small"
                              onClick={() => resetTransform()}
                            >
                              Reset
                            </Button>
                            <Button
                              startIcon={<SaveAltRoundedIcon />}
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => downloadImage(Image, `alert_${id}.png`)}
                            >
                              Download
                            </Button>
                          </Box>
                        </>
                      )}
                    </TransformWrapper>
                  </div>

                  {/* Alert Response Section */}
                  <Box
                    sx={{
                      padding: 2,
                      backgroundColor: 'background.paper',
                      borderRadius: '8px',
                      border: '2px solid',
                      borderColor: 'divider',
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1.5 }}>
                      Is this alert accurate?
                    </Typography>
                    <ButtonGroup variant="outlined" fullWidth sx={{ gap: 1 }}>
                      <Button
                        fullWidth
                        onClick={() => handleAlertResponse(true)}
                        disabled={isSubmitting || userResponse !== null}
                        sx={{
                          color: userResponse === true ? '#fff' : '#4caf50',
                          backgroundColor: userResponse === true ? '#4caf50' : 'transparent',
                          borderColor: '#4caf50',
                          '&:hover': {
                            backgroundColor: userResponse === true ? '#45a049' : 'rgba(76, 175, 80, 0.08)',
                          },
                          fontWeight: 'bold',
                          padding: '10px',
                        }}
                        startIcon={<CheckCircleIcon />}
                      >
                        ✓ True Positive
                      </Button>
                      <Button
                        fullWidth
                        onClick={() => handleAlertResponse(false)}
                        disabled={isSubmitting || userResponse !== null}
                        sx={{
                          color: userResponse === false ? '#fff' : '#f44336',
                          backgroundColor: userResponse === false ? '#f44336' : 'transparent',
                          borderColor: '#f44336',
                          '&:hover': {
                            backgroundColor: userResponse === false ? '#da190b' : 'rgba(244, 67, 54, 0.08)',
                          },
                          fontWeight: 'bold',
                          padding: '10px',
                        }}
                        startIcon={<CancelIcon />}
                      >
                        ✗ False Positive
                      </Button>
                    </ButtonGroup>
                    {userResponse !== null && (
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'block',
                          marginTop: 1,
                          color: userResponse ? '#4caf50' : '#f44336',
                          fontWeight: 'bold'
                        }}
                      >
                        Response submitted: {userResponse ? 'True Positive' : 'False Positive'}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <MuiAlert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
};
